import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppStateProvider } from './state/AppStateContext';
import { ToastProvider } from './components/ui/ToastProvider';
import { AppRouter } from './app/AppRouter';
import './styles.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppStateProvider>
        <ToastProvider>
          <AppRouter />
        </ToastProvider>
      </AppStateProvider>
    </BrowserRouter>
  </React.StrictMode>
);
